import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface GetEventPaymentHistoryParams {
  eventId: string;
}

export interface EventPaymentHistoryInvoice {
  _id: string;
  studentId: string | null;
  studentName: string;
  paymentStatus: string;
  enrollmentStatus: string;
  enrollmentDate: string | null;
  dueDate: string | null;
  totalAmount: number | null;
  amount: number | null;
  paymentIntentId: string | null;
  problem: string;
}

export const getEventPaymentHistory = async ({
  eventId,
}: GetEventPaymentHistoryParams) => {
  const response = await baseAPI.get<Array<EventPaymentHistoryInvoice>>(
    `/subscription-invoices/payment-history/event/${eventId}`,
  );
  return response.data;
};

export const useGetEventPaymentHistory = (
  params: GetEventPaymentHistoryParams,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.EVENT_PAYMENT_HISTORY(params),
    queryFn: () => getEventPaymentHistory(params),
    staleTime: 1000 * 60 * 3,
    refetchInterval: 1000 * 60 * 3,
  });
};
